// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__25EGU","choiceBoxes":"toolbarselects_choiceBoxes__2erxs","simpleField":"toolbarselects_simpleField__3xE_H"};